/*******************************************************
 * ROUTES SERVICE
 *******************************************************/

"use strict";


/**
 * Module SERVICES
 */
angular.module("services")

	.factory("TransportControlPlanService", ["$http", "ENV", function ($http, ENV) {

		return {
			download: download
		};


		/**
         * Retourne les informations d'un réseau
         * @param pattern
         * @returns {*}
         */
		function download(lineId, format) {
			return $http.get(ENV.API_URL + "/transport-control-plan/"+lineId+"/"+format, {
				responseType: "arraybuffer",
				headers: {
					"Content-Type": "application/octet-stream"
				}
			});
		}

	}]);


